// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0cbaba7d8a--wrapper--PEdJB","full-with":"_0cbaba7d8a--full-with--VRkMb","fill_secondary":"_0cbaba7d8a--fill_secondary--KAiHk"};